import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
  src: string = "assets/logo.png?v" + Math.random();

  constructor() { }

  ngOnInit() {
  }

}
